import type { ReactNode } from 'react';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { formatDateTime } from '../../../utils/format-date-time.util';
import { EmailAddress } from '../../../components/EmailAddress';

export const UserPage_Account_User_Fragment = graphql(`
  fragment UserPage_Account_User_Fragment on User {
    email
    lastSeenAt
  }
`);

interface Props {
  readonly user: FragmentType<typeof UserPage_Account_User_Fragment>;
  readonly actions?: ReactNode;
}

export const Account = ({ user: pUser, actions }: Readonly<Props>) => {
  const user = getFragmentData(UserPage_Account_User_Fragment, pUser);

  return (
    <Stack spacing={2} sx={{ pt: 4, width: '100%' }}>
      <Paper sx={{ p: 2 }}>
        <Box sx={{ position: 'relative' }}>
          <Typography gutterBottom variant="body1">
            Adresse e-mail : <EmailAddress eMail={user.email} />
          </Typography>
          <Typography gutterBottom variant="body1">
            Mot de passe : &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;
          </Typography>
          <Typography gutterBottom variant="body1">
            Date de dernière connexion :{' '}
            {user.lastSeenAt
              ? formatDateTime(user.lastSeenAt)
              : 'Aucune connexion'}
          </Typography>
        </Box>
      </Paper>
      {actions}
    </Stack>
  );
};
